import { Service } from '../types'

export const services: Service[] = [
  {
    id: '1',
    title: 'Construction',
    description: 'SKY Wall – a highly capable Civil General Contractor has contributed immensely to the growth of the UAE by way of its projects in construction of villa, residential building, commercial and industrial projects.',
    image: '/images/services/services-construction.jpg',
    features: [
      'Residential Construction',
      'Commercial Buildings',
      'Villa Construction',
      'Industrial Projects',
      'Core and Shell Works',
      'MEP Integration'
    ],
    icon: 'Building'
  },
  {
    id: '2',
    title: 'MEP Works',
    description: 'MEP team of MultiTech is an expert task force to reckon when your commercial, residential, industrial buildings or projects needs to attain 100% efficiency. We are one of the leading development contractors who take care right from planning, execution and delivery of your projects.',
    image: '/images/services/services-mep-works.jpg',
    features: [
      'Mechanical Works',
      'Electrical Works',
      'Plumbing Works',
      'Fire Fighting Systems',
      'Testing & Commissioning',
      '100% Efficiency Solutions'
    ],
    icon: 'Zap'
  },
  {
    id: '3',
    title: 'Interiors',
    description: 'Our designs offer unlimited solutions through a careful managing and planning approach. With a vast experienced team of designers, we create interior works in recognized hotels, offices, hospitals and more. Our services consist of supplying and installing soft and hard furniture in addition to soft furnishing, curtains, wall paper and accessories.',
    image: '/images/services/services-interiors.jpg',
    features: [
      'Civil & Carpentry',
      'Electrical & Lighting',
      'Decorative & Finishing',
      'Furnishing & Fit-out',
      'Testing & Quality Control',
      'Hotel & Office Interiors'
    ],
    icon: 'Palette'
  },
  {
    id: '4',
    title: 'Scaffolding',
    description: 'Scaffolding is an integral part of all kind of construction projects and it has been used ever since the first structure is built, Scaffolding supports to get access to the structures at height during construction. We are having highly skilled, well trained and certified scaffolders having wider experiences on all kind of scaffolding works.',
    image: '/images/services/services-scaffolding.jpg',
    features: [
      'Certified',
      'Height Access Solutions',
      'Construction Support',
      'Safety Compliance',
      'All Types of Scaffolding',
      'Professional Installation'
    ],
    icon: 'Shield'
  }
]
